import { collection, get, all, query, where, update } from "typesaurus"
import { GeoState, GroupType, AccountType } from "../types"

export interface District {
  id: string
  created: number
  createdBy: string
  lastModified: number
  name: string
  groupType: GroupType
  accountType: AccountType
  keyReveal?: Array<{
    testName: string
    revealDate: number
    assessmentId: string
    testCategory: string
  }>
  state: GeoState
  schools: { [key: string]: boolean }
  admins: { [key: string]: boolean }
  sfid?: string
  deleted?: boolean
  isACTDistrict?: boolean
  permissions?: {
    Schools: { email: boolean; password: boolean }
    Teachers: { email: boolean; password: boolean }
    Students: { email: boolean; password: boolean }
  }
}

const collection_ref = collection<District>("districts")

export const getDistrictById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllDistricts = () => {
  return all(collection_ref)
}

export const updateDistrictById = (id: string, newVals: Partial<District>) => {
  return update(collection_ref, id, newVals)
}

export const getDistrictsByState = (geoState: GeoState) => {
  return query(collection_ref, [where("state", "==", geoState)])
}
